import React from 'react'

const ForgotPassword = () => {
  return (
    <div>
      forgot pass
    </div>
  )
}

export default ForgotPassword
